import React from 'react';
import { Home, Activity, Users, Eye } from 'lucide-react';
import { useLanguage } from '../../../contexts/LanguageContext';
import Icon from '../../../components/AppIcon';


const MetricsBar = ({ metrics }) => {
  const { t } = useLanguage();

  const cards = [
    { label: t('totalListings'), value: metrics?.total ?? 0, icon: Home, color: '#00D4FF' },
    { label: t('activeLive'), value: metrics?.active ?? 0, icon: Activity, color: '#00FF88' },
    { label: t('leadsGenerated'), value: metrics?.leads ?? 0, icon: Users, color: '#7B2FFF' },
    { label: t('monthlyViews'), value: (metrics?.views ?? 0)?.toLocaleString(), icon: Eye, color: '#FFB800' },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
      {cards?.map((card, i) => {
        const Icon = card?.icon;
        return (
          <div key={i} className="p-5 rounded-2xl" style={{
            background: 'rgba(0, 212, 255, 0.04)',
            border: '1px solid rgba(0, 212, 255, 0.12)'
          }}>
            <div className="flex items-center justify-between mb-3">
              <span className="text-xs font-medium" style={{ color: '#4A7A9B' }}>{card?.label}</span>
              <div className="w-8 h-8 rounded-lg flex items-center justify-center" style={{
                background: `${card?.color}20`,
                border: `1px solid ${card?.color}30`
              }}>
                <Icon size={15} color={card?.color} />
              </div>
            </div>
            <div className="text-2xl font-bold" style={{ color: card?.color }}>{card?.value}</div>
          </div>
        );
      })}
    </div>
  );
};

export default MetricsBar;
